module.exports = {
  language: 'English',
  hello: 'apple'
}
